
import React from 'react';
import { VideoEvent } from '@/hooks/useVideoEvents';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface PropertyItemProps {
  label: string;
  value: string;
}

const PropertyItem: React.FC<PropertyItemProps> = ({ label, value }) => {
  return (
    <div>
      <h4 className="text-sm font-medium text-gray-500">{label}</h4>
      <p className="text-base">{value}</p>
    </div>
  );
};

interface PropertiesTabProps {
  video: VideoEvent;
}

const PropertiesTab: React.FC<PropertiesTabProps> = ({ video }) => {
  const formattedDate = video.date ? 
    format(video.date, 'd MMMM yyyy à HH:mm', { locale: fr }) : 
    'Date inconnue';
    
  return (
    <div className="p-6">
      <h3 className="text-lg font-medium mb-4">Propriétés de la vidéo</h3>
      
      <div className="space-y-4">
        <PropertyItem label="Titre" value={video.title} />
        <PropertyItem label="ID de la vidéo" value={video.videoId || "Non disponible"} />
        <PropertyItem label="Date de publication" value={formattedDate} />
        <PropertyItem label="Statut" value={video.status || "Publié"} />
        <PropertyItem label="Type de contenu" value={video.contentType || "Vidéo"} />
      </div>
    </div>
  );
};

export default PropertiesTab;
